<script>
  import * as Store from "./stores.js";
  export let group;
  export let value;
  export let displayValue = null;
  export let description;
  export let discountText = null;
  export let img;

  function goToNext() {
    const grids = document.querySelectorAll(".grid");
    let nextSection = document.querySelector(".subscriptions-summary");

    // Delay to account for class update
    setTimeout(() => {
      for (const grid of grids) {
        if (!grid.querySelector(".is-selected")) {
          nextSection = grid.closest(".subscriptions-section");
          break;
        }
      }

      // Add padding/offset to scroll position
      const offset = 160;
      const y = nextSection.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }, 200);
  }

  // NOTE: I'm using the "Store[group]" instead of e.g. "flavorProfile" to DRY up things a bit
  function setValue(newValue, newDisplayValue) {
    Store[group].update(() => newValue);
    Store[`${group}DisplayValue`].update(() => newDisplayValue);
    goToNext();
  }

  let selectedValue;
  Store[group].subscribe(value => {
    selectedValue = value;
  });
</script>

<div class="grid-item">
  <button
    on:click={() => setValue(value, displayValue || value)}
    type="button"
    class="image_card {selectedValue === value ? 'is-selected' : ''}"
    title="Select {displayValue || value}">
    <div class="image_card-image js-image_card-image">
      <div class="image_card-image-helper">
        <img src={img} alt="" style="max-width: 200px;" />
      </div>
    </div>
    <div class="image_card-content">
      <h2 class="image_card-heading">{displayValue || value}</h2>
      <p>{description}</p>
      {#if discountText}
        <h3 class="discount">{discountText}</h3>
      {/if}
    </div>
  </button>
</div>
